import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/layout/ScrollToTop';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import FloatingPhone from './components/layout/FloatingPhone';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import ServiceAreas from './pages/ServiceAreas';
import Financing from './pages/Financing';
import Maintenance from './pages/Maintenance';
import Quote from './pages/Quote';

function App() {
  return (
    <Router basename="/projects/northpeak-hvac">
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/areas" element={<ServiceAreas />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/contact" element={<Quote />} /> {/* Alias contact to quote for simplicity */}
          </Routes>
        </main>
        <Footer />
        <FloatingPhone />
      </div>
    </Router>
  );
}

export default App;
